import Skeleton from 'react-loading-skeleton';

const DossierDetailsFetching = () => {
  return (
    <div className="spo-o-dossier-detail-fetching">
      <div className="row u-margin-bottom-xs">
        <div className="col-xs-6">
          <h4 className="u-text-light">Dossier ophalen...</h4>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-4">
          <p>
            <Skeleton />
          </p>
        </div>
      </div>
      <div className="row u-margin-top-xs">
        <div className="col-xs-3">
          <Skeleton />
        </div>
        <div className="col-xs-3">
          <Skeleton />
        </div>
        <div className="col-xs-3">
          <Skeleton />
        </div>
        <div className="col-xs-3">
          <Skeleton />
        </div>
      </div>
      <div className="u-flex u-margin-top">
        <div className="tab">
          <Skeleton />
        </div>
        <div className="tab">
          <Skeleton />
        </div>
        <div className="tab">
          <Skeleton />
        </div>
        <div className="tab">
          <Skeleton />
        </div>
        <div className="tab">
          <Skeleton />
        </div>
        <div className="tab">
          <Skeleton />
        </div>
        <div className="tab">
          <Skeleton />
        </div>
        <div className="tab">
          <Skeleton />
        </div>
      </div>
      <div className="body u-padding u-margin-top">
        <div className="row u-margin-bottom">
          <h3 className="col-xs-4">
            <Skeleton />
          </h3>
        </div>
        <div className="row">
          <p className="col-xs-6">
            <Skeleton />
          </p>
        </div>
        <div className="row">
          <p className="col-xs-4">
            <Skeleton />
          </p>
        </div>
        <div className="row">
          <p className="col-xs-6">
            <Skeleton />
          </p>
        </div>
      </div>
    </div>
  );
};

export default DossierDetailsFetching;
